// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

Vue.config.productionTip = false;

//promise
import babelpolyfill from "babel-polyfill";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Quill from "quill";
import ImageResize from "quill-image-resize-module"; //添加
Quill.register("modules/imageResize", ImageResize); //添加

Vue.use(VueQuillEditor);

//element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

//preview图片预览 preview="index"
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
Vue.use(preview);

//axios
import axios from "axios";
Vue.prototype.axios = axios;


// 引入store
import store from "./store";

Vue.prototype._url = "https://nkd-1257347508.cos.ap-shanghai.myqcloud.com/";
Vue.prototype._cos = {
  url: "https://nkd-1257347508.cos.ap-shanghai.myqcloud.com/",
  SecretId: "AKID0zlbCXScKmywf8hkyvc3zGGzeqmSB5AK",
  SecretKey: "2nJabO0Vt0tWXJqLCNI0TiqiJMq8AwTm",
  Bucket: "nkd-1257347508", // Bucket 格式：BucketName-APPID
  Region: "ap-shanghai"
};

Vue.prototype._partnerType = [];

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js